import * as Yup from "yup";

const formatDateTimeToInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export function initialValues(liveClass) {
  return {
    name: liveClass?.name || "",
    description: liveClass?.description || "",
    scheduledAt: formatDateTimeToInput(liveClass?.scheduledAt) || "",
    durationMinutes: liveClass?.durationMinutes || 60,
    levelId: liveClass?.syllabuSubjectGrade?.grade?.levelId || liveClass?.levelId || "",
    gradeId: liveClass?.syllabuSubjectGrade?.gradeId || liveClass?.gradeId || "",
    subjectId: liveClass?.syllabuSubjectGrade?.subjectId || liveClass?.subjectId || "",
    teacherId: liveClass?.teacherId || "",
    accessCode: liveClass?.accessCode || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
    description: Yup.string(),
    scheduledAt: Yup.string().required("La fecha y hora es obligatoria"),
    durationMinutes: Yup.number().min(1, "Duración mínima 1 minuto").required("La duración es obligatoria"),
    levelId: Yup.string().required("El nivel es obligatorio"),
    gradeId: Yup.string().required("El grado es obligatorio"),
    subjectId: Yup.string(),
    teacherId: Yup.string(),
    accessCode: Yup.string(),
  });
}
